import qrcode from "qrcode-generator";

export default class MobilePairingModalController {

  constructor($scope, $uibModalInstance, pairingUrl, UserPreferenceService) {
    const qrCode = qrcode(0, "M");
    qrCode.addData(pairingUrl);
    qrCode.make();
    $scope.qrCode = qrCode.createDataURL(6, 4);

    $scope.close = function () {
      $uibModalInstance.close();
    };

    $scope.$on(UserPreferenceService.MOBILE_APP_PAIRING_NOTIFIED, $scope.close);
  }
}
